import React, { useEffect, useState } from "react";
import "./Step2.css";
import { Form } from "react-bootstrap";

function Step2({ next, back, setEnrollStudents, enrollStudents }) {
  const [selectedOption, setSelectedOption] = useState("");

  const radioOptions = [
    "Word of Mouth / Referrals",
    "Social Media Posts",
    "Facebook / Google Ads",
    "Agents / Counselors",
    "Other (please specify)",
  ];

  const [otherValue, setOtherValue] = useState("");

  const handleSelect = (label) => {
    setSelectedOption(label);
    setEnrollStudents(label); // <-- store selected into setSegmentSuited

    if (label !== "Other (please specify)") {
      setOtherValue(""); // reset if not other
    }
  };

  useEffect(() => {
    if (selectedOption === "Other (please specify)") {
      setEnrollStudents(otherValue);
    }
  }, [otherValue]);

  return (
    <div className="step2_main">
      <h2 className="step_title">
        Just Answer <span>6</span> Simple questions to become a <br />
        <strong>Profcyma Partner</strong>
      </h2>
      <p className="step_subtitle">
        What process do you use to enroll new students?
      </p>

      <div className="form_holder">
        <div className="list_holder">
          {radioOptions.map((label, index) => (
            <label
              key={index}
              className={`option_box ${
                enrollStudents === label ? "active" : ""
              }`}
              onClick={() => handleSelect(label)}
            >
              {label}

              <Form.Check
                type="radio"
                name="seg"
                className="option_radio"
                value={label}
                checked={enrollStudents === label}
                onChange={() => handleSelect(label)}
              />
            </label>
          ))}
        </div>

        {/* Show input only when "Other" selected */}
        {selectedOption === "Other (please specify)" && (
          <input
            type="text"
            className="other_input"
            placeholder="Please specify"
            value={otherValue}
            onChange={(e) => setOtherValue(e.target.value)}
          />
        )}
      </div>

      <div className="step_btns">
        <button onClick={back} className="back_btn">
          Back
        </button>
        <button onClick={next} className="next_btn">
          Next
        </button>
      </div>
    </div>
  );
}

export default Step2;
